import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/** Telas do profissional logado (papel Professional). */
export const PROFESSIONAL_ROUTES = ['meus-agendamentos', 'perfil'];

/**
 * Separa as áreas: o profissional só abre as telas dele; o Admin não abre as do profissional.
 * A API também bloqueia (o profissional só acessa /api/me).
 */
export const roleGuard: CanActivateChildFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const path = route.routeConfig?.path ?? '';
  const professionalArea = PROFESSIONAL_ROUTES.includes(path);
  if (auth.isProfessional() !== professionalArea) return router.createUrlTree([auth.homeRoute()]);
  return true;
};
